<template>
  <v-dialog
    :model-value="Boolean(boundValue)"
    @update:model-value="onDialogUpdate"
    fullscreen
    content-class="dialog-fullscreen-overlay"
  >
    <div
      class="dialog-fullscreen"
    >
      <slot name="prepend"></slot>
      <v-card
        color="transparent"
        rounded="0"
        flat
      >
        <v-toolbar
          theme="dark"
          color="primary"
          density="compact"
        >
          <v-btn
            icon
            theme="dark"
            @click="emitBoundValue(null)"
            size="small"
          >
            <v-icon size="small">mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
        </v-toolbar>
        <slot></slot>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import modelValueCompat from '@/mixins/modelValueCompat';

export default {
  name: 'BaseDialogFullscreen',

  mixins: [modelValueCompat],

  inheritAttrs: false,

  props: {
    title: {
      type: String,
      default: "",
    },
  },

  emits: ['update:modelValue', 'input'],

  methods: {
    onDialogUpdate(isOpen) {
      if (!isOpen) {
        this.emitBoundValue(null);
      }
    },
  },
};
</script>

<style scoped>
.dialog-fullscreen {
  height: 100%;
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.85);
  /*backdrop-filter: blur(2px); This property breaks position fixed in Contact Filter Condition Editor */
}
.theme--dark .dialog-fullscreen,
.v-theme--dark .dialog-fullscreen {
  background: rgba(0, 0, 0, 0.85);
}
</style>

<style>
.dialog-fullscreen-overlay {
  overflow-x: hidden !important;
  max-width: 100vw;
  width: 100%;
}
</style>
